import { FBBlue, Facebook, Google } from "@assets/index";
import React, { useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { parsePhoneNumber } from "react-phone-number-input";
import OTPInput from "react-otp-input";

import styles from "./styles";
import { useResendOtpMutation, useUserSignupMutation, useVerifyOtpMutation } from "./signupSlice";
import LocalStorage from "@Utils/storage";
import { Tokens } from "@Constants/common";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@Constants/routes";
import { displayToast } from "@Utils/toast";
import { setUser } from "@Pages/Profile/profileSlice";
import { useAppDispatch } from "@Store/store";
import { CheckCircledIcon, CheckIcon } from "@radix-ui/react-icons";
import { CheckBadgeIcon, CheckCircleIcon } from "@heroicons/react/24/solid";

import { CheckPasswordStrength, deleteUTMCookies, getReferralIdFromCookie, getUtmParamsFromCookies } from "@Utils/common";

const SignupForm = () => {
    const navigate = useNavigate();

    // const notify = () => toast.error("Wow so easy !", { theme: 'colored'});

    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState<string | any>("");
    const [otp, setOtp] = useState<string>("");
    const [showOtp, setShowOtp] = useState<boolean>(false);
    const [isPasswordStrong, setIsPasswordStrong] = useState(false);

    const [errors, setErrors] = useState<{ [key: string]: string }>({});


    const [refId, setRefId] = useState<string | null>("");

    const [timeLeft, setTimeLeft] = useState(15);
    const [canResend, setCanResend] = useState(false);


    const [
        userSignup,
        {
            data: userSignupData,
            error: userSignupErr,
            isLoading: userSignupLoading,
        },
    ] = useUserSignupMutation();

    const [verifyOtp, { data: verifyOtpData, error: verifyOtpErr }] = useVerifyOtpMutation();
    const [resendOtp, { data: resendOtpData, error: resendOtpError }] = useResendOtpMutation();

    useEffect(() => {
        if (timeLeft > 0) {
            const timer = setTimeout(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);

            return () => clearTimeout(timer);
        } else {
            setCanResend(true);
        }
    }, [timeLeft]);


    const onResendOTPClick = (e: any) => {
        resendOtp({ email })
    }

    useEffect(() => {
        console.log(resendOtpData, resendOtpError)
        if (resendOtpData) {
            displayToast("success", resendOtpData?.message);
            setTimeLeft(15)
        }

        if (verifyOtpErr) {
            displayToast("error", resendOtpError?.message);
        }
    }, [resendOtpData, resendOtpError])

    useEffect(() => {
        const referral_id = getReferralIdFromCookie();
        setRefId(referral_id);

    }, [])



    const dispatch = useAppDispatch();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        if (e?.target?.name == "email") setEmail(e.target.value);
        if (e?.target?.name == "password") setPassword(e.target.value);
        if (e?.target?.name == "firstname") setFirstName(e.target.value);
        if (e?.target?.name == "lastname") setLastName(e.target.value);
        if (e?.target?.name == "phonenumber") setPhoneNumber(e.target.value);
    };

    // useEffect(() => {
    //     validateFields();
    // }, [firstName, lastName, email, password, phoneNumber]);


    useEffect(() => {
        const passwordStrength = CheckPasswordStrength(password);
        setIsPasswordStrong(passwordStrength);
    }, [password]);

    const validateFields = () => {
        const newErrors: { [key: string]: string } = {};

        if (!firstName.trim()) {
            newErrors.firstname = "First name is required";
        }

        if (!lastName.trim()) {
            newErrors.lastname = "Last name is required";
        }

        if (!email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
            newErrors.email = "Invalid email format";
        }

        if (!phoneNumber) {
            newErrors.phonenumber = "Phone number is required";
        } else {
            try {
                const parsed = parsePhoneNumber(phoneNumber);
                if (!parsed || !parsed.isValid()) {
                    newErrors.phonenumber = "Invalid phone number";
                }
            } catch (err) {
                newErrors.phonenumber = "Invalid phone number";
            }
        }

        if (!password) {
            newErrors.password = "Password is required";
        } else if (!CheckPasswordStrength(password)) {
            newErrors.password = "Password is not strong enough";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    const onSubmitClick = (e: any) => {
        e.preventDefault();
        // notify()
        if (!validateFields()) {
            displayToast("error", "Please fix the highlighted errors.");
            return;
        }
        
        const utm = getUtmParamsFromCookies()
        userSignup({
            email,
            password,
            first_name: firstName,
            last_name: lastName,
            phone_number: phoneNumber,
            ref_id: refId,
            ...utm
        });

    };

    const handleOtp = (e: any) => {
        e.preventDefault();
        verifyOtp({ otp });
    };

    useEffect(() => {
        if (userSignupData?.status) {
            LocalStorage.setItem(
                Tokens.ACCESS_TOKEN,
                userSignupData.data.user_access_token
            );
            LocalStorage.setItem(
                Tokens.REFRESH_TOKEN,
                userSignupData.data.refresh_user_access_token
            );

            displayToast("success", "User Signup Successful");
            deleteUTMCookies()
            if (userSignupData?.user?.verified == 0) {
                setShowOtp(true);
                setTimeLeft(15)
            }
            dispatch(setUser(userSignupData.user));
            // if (userSignupData.status) navigate(ROUTES.CONNECT_FACEBOOK)
        }
        if (userSignupErr) {
            // setShowError(parseErrorMessage(verifyErr));
            displayToast("error", userSignupErr?.data?.message);
            console.error(userSignupErr?.data);
        }
    }, [userSignupData, userSignupErr]);

    useEffect(() => {
        if (verifyOtpData?.status) {
            displayToast("success", "Email Verified Successfully");
            navigate(ROUTES.IG_CONNECT);
        }

        if (verifyOtpErr) {
            // setShowError(parseErrorMessage(verifyErr));
            displayToast("error", verifyOtpErr?.data?.message);
        }
    }, [verifyOtpData, verifyOtpErr]);

    

    return (
        <div className="w-full">
            {showOtp ? (
                <>
                    <div className="text-center mb-6">
                        <h2 className="text-[1.2rem] font-semibold mb-2">
                            Verify Email
                        </h2>
                        <p className="text-[#787781] text-sm">
                            Email is sent on <span className="text-[#7772FF]">{email}</span>
                        </p>
                        <p className="text-[#787781] text-sm mt-1">(Check your spam if you haven't received)</p>
                    </div>
                    <form className="w-full space-y-4">
                        <div className="flex justify-center items-center gap-2">
                            <OTPInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                renderSeparator={<span className="mx-1"></span>}
                                inputStyle={{ width: '40px', height: '40px' }}
                                renderInput={(props) => (
                                    <input
                                        {...props}
                                        className="text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
                                    />
                                )}
                            />
                        </div>
                        <button
                            className="w-full bg-[#7772FF] text-white py-3 rounded-lg font-medium hover:bg-[#6561FF] transition-colors disabled:opacity-50"
                            onClick={handleOtp}
                        >
                            Verify
                        </button>
                        <div className="text-center">
                            <button
                                className={`text-sm ${timeLeft ? 'text-[#787781]' : 'text-[#7772FF] hover:underline'}`}
                                disabled={timeLeft > 0}
                                onClick={onResendOTPClick}
                            >
                                Resend OTP {timeLeft ? `(${timeLeft})` : ''}
                            </button>
                        </div>
                    </form>
                </>
            ) : (
                <>
                    <form className="w-full space-y-4">
                        
                        {/* First & Last Name Fields */}

                        <div className="flex flex-col sm:flex-row gap-4">
                            <div className="w-full">
                                <input
                                    type="text"
                                    name="firstname"
                                    placeholder="First Name"
                                    value={firstName}
                                    onChange={handleChange}
                                    className={`w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 ${errors.firstname ? "border-red-600" : ""} focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent`}
                                />
                                {errors.firstname && <p className="text-xs text-red-500 mt-1">{errors.firstname}</p>}
                            </div>
                            <div className="w-full">
                                <input
                                    type="text"
                                    name="lastname"
                                    placeholder="Last Name"
                                    value={lastName}
                                    onChange={handleChange}
                                    className={`w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 ${errors.lastname ? "border-red-600" : ""} focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent`}
                                />
                                {errors.lastname && <p className="text-xs text-red-500 mt-1">{errors.lastname}</p>}
                            </div>
                        </div>

                        {/* Phone Input */}
                        <div>
                            <style>
                                {`
                                    .PhoneInput {
                                        display: flex;
                                        align-items: center;
                                        gap: 8px;
                                        width: 100%;
                                        padding: 0.75rem 1rem;
                                        border-radius: 0.5rem;
                                        background-color: rgb(249 250 251);
                                        border: 1px solid rgb(229 231 235);
                                    }
                                    .PhoneInput:focus-within {
                                        outline: none;
                                        border-color: #7772FF;
                                        box-shadow: 0 0 0 2px rgba(119, 114, 255, 0.2);
                                    }
                                    .PhoneInputInput {
                                        border: none;
                                        background: transparent;
                                        padding: 0;
                                        outline: none;
                                        flex: 1;
                                    }
                                    .PhoneInputCountry {
                                        display: flex;
                                        align-items: center;
                                    }
                                `}
                            </style>
                            <PhoneInput
                                placeholder="Enter your phone number"
                                defaultCountry="IN"
                                countryCallingCodeEditable={false}
                                international
                                initialValueFormat="national"
                                value={phoneNumber}
                                onChange={setPhoneNumber}
                            />
                            {errors.phonenumber && <p className="text-xs text-red-500 mt-1">{errors.phonenumber}</p>}
                        </div>

                        {/* Email Field */}
                        <div>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email Address"
                                value={email}
                                onChange={handleChange}
                                className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
                            />
                            {errors.email && <p className="text-xs text-red-500 mt-1">{errors.email}</p>}
                            {email && (
                                <p className="text-xs text-[#787781] mt-1">
                                    Email will be sent to <span className="text-[#7772FF]">{email}</span> for verification
                                </p>
                            )}
                        </div>

                        {/* Password Field */}
                        <div>
                            <input
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={password}
                                onChange={handleChange}
                                autoComplete="new-password"
                                className="w-full px-4 py-3 rounded-lg bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#7772FF] focus:border-transparent"
                            />
                            {!password && errors.password && (
                                <p className="text-xs text-red-500 mt-1">{errors.password}</p>
                            )}
                            {password && (
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-2">
                                    <div className={`flex items-center gap-1 text-xs ${password.length >= 8 ? "text-emerald-500" : "text-red-500"}`}>
                                        <CheckCircledIcon className="w-4 h-4" />
                                        <span>Minimum 8 Characters</span>
                                    </div>
                                    <div className={`flex items-center gap-1 text-xs ${/(?=.*[a-z])(?=.*[A-Z])/.test(password) ? "text-emerald-500" : "text-red-500"}`}>
                                        <CheckCircledIcon className="w-4 h-4" />
                                        <span>Upper & Lower case</span>
                                    </div>
                                    <div className={`flex items-center gap-1 text-xs ${/\d/.test(password) ? "text-emerald-500" : "text-red-500"}`}>
                                        <CheckCircledIcon className="w-4 h-4" />
                                        <span>One Numerical (123)</span>
                                    </div>
                                    <div className={`flex items-center gap-1 text-xs ${/[!@#$%^&*(),.?":{}|<>]/.test(password) ? "text-emerald-500" : "text-red-500"}`}>
                                        <CheckCircledIcon className="w-4 h-4" />
                                        <span>Special Char (@#$%)</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Meta Verification Box */}
                        <div className="bg-[#F9F9FB] rounded-xl p-4 border border-black">
                            <div className="flex items-center justify-center gap-2 mb-2">
                                <img
                                    src="https://img.icons8.com/?size=100&id=PvvcWRWxRKSR&format=png&color=000000"
                                    alt="check"
                                    className="w-8 h-8"
                                />
                                <h3 className="text-[#1877f2] font-semibold text-base">
                                    We're a Meta-verified business
                                </h3>
                            </div>
                            <p className="text-[#787781] text-xs text-center">
                                We only use official Instagram APIs and processes.<br />
                                Your Instagram account is secure, and you stay in full control.
                            </p>
                        </div>

                        {/* Terms & Policy Notice */}
                        <div className="text-center">
                            <p className="text-xs text-[#787781]">
                                By signing up you agree to the{" "}
                                <a href="https://linkplease.co/terms-and-conditions/" className="text-[#6561FF] hover:underline">Terms</a> and{" "}
                                <a href="https://linkplease.co/privacy-policy" className="text-[#6561FF] hover:underline">Privacy Policy</a>
                            </p>
                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            onClick={onSubmitClick}
                            className="w-full bg-[#3535d5] text-white py-3 rounded-lg font-medium hover:bg-[#6561FF] transition-colors disabled:opacity-50"
                        >
                            Create Account
                        </button>
                    </form>

                </>
            )}
        </div>
    );
};

export default SignupForm;
